import { useTranslation } from 'react-i18next'
import PageLayout from '@BUP/components/Layout/Page'
import { ComplaintForm } from '@BUP/components/complaint/form'

export function LogbookNewComplaintPage () {
  const i18n = useTranslation()
  return (
    <PageLayout backButton pageName={i18n.t('pages.logbook.new.title')}>
      <ComplaintForm />
    </PageLayout>
  )
}
